import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    templateUrl: './component.dialog.terms.html',
    styleUrls: ['./component.dialog.terms.css']
})
export class ComponentDialogTerms{
    
    showFooter: boolean = true;
    
    constructor(
        public dialogRef: MatDialogRef<ComponentDialogTerms>
    ){}

    onClickAccept(){
        this.dialogRef.close();
    }

}